<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules" >
      <a-form-model-item :label="$t('views.systemNotice.form.noticeType')" prop="noticeType">
        <a-select v-model="form.noticeType" :placeholder="$t('views.systemNotice.form.noticeTypePlaceholder')" style="width: 100%">
          <a-select-option :value="1">{{ $t('views.systemNotice.type.notice') }}</a-select-option>
          <a-select-option :value="2">{{ $t('views.systemNotice.type.versionUpdate') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemNotice.form.title')" prop="noticeTitle">
        <a-input size="large" width="200px" v-model="form.noticeTitle" :placeholder="$t('views.systemNotice.form.titlePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemNotice.form.titleEn')" prop="noticeTitleEn">
        <a-input size="large" v-model="form.noticeTitleEn" :placeholder="$t('views.systemNotice.form.titleEnPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemNotice.form.image')" prop="imgUrl" >
        <file-upload v-model="form.imgUrl" type="image" @change="changeSwiper"></file-upload>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemNotice.form.content')" prop="noticeContent">
        <editor :key="'notice-content-' + (form.id || 'new')" v-model="form.noticeContent" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.systemNotice.form.contentEn')" prop="noticeContentEn">
        <editor :key="'notice-contentEn-' + (form.id || 'new')" v-model="form.noticeContentEn" />
      </a-form-model-item>
    </a-form-model>
    <div class="bottom-control">
      <a-space>
        <a-button type="primary" :loading="submitLoading" @click="submitForm">
          {{ $t('views.systemNotice.form.save') }}
        </a-button>
        <a-button type="dashed" @click="cancel">
          {{ $t('views.systemNotice.form.cancel') }}
        </a-button>
      </a-space>
    </div>
  </a-drawer>
</template>

<script>

import { getNotice, addNotice, updateNotice } from '@/api/system/notice'
import Editor from '@/components/Editor'
import events from '@/components/MultiTab/events'

export default {
  name: 'NoticeForm',
  components: {
    Editor
  },
  dicts: ['sys_notice_status', 'sys_notice_type'],
  data () {
    return {
      wrapperCol: { span: 48 },
      submitLoading: false,
      total: 0,
      id: undefined,
      formType: 1,
      form: {
        id: undefined,
        noticeTitle: undefined,
        noticeTitleEn: undefined,
        noticeType: 1,
        noticeContent: '',
        noticeContentEn: '',
        imgUrl: null,
        status: 1,
        bstatus: 1
      },
      open: false
    }
  },
  computed: {
    formTitle () {
      return this.formType === 1
        ? this.$t('views.systemNotice.title.add')
        : this.$t('views.systemNotice.title.edit')
    },
    rules () {
      return {
        noticeType: [{ required: true, message: this.$t('views.systemNotice.rule.typeRequired'), trigger: 'change' }],
        noticeTitle: [{ required: true, message: this.$t('views.systemNotice.rule.titleRequired'), trigger: 'blur' }],
        noticeContent: [{ required: true, message: this.$t('views.systemNotice.rule.contentRequired'), trigger: 'blur' }]
      }
    }
  },
  mounted () {
  },
  methods: {
    changeSwiper (e) {
      this.form.imgUrl = e
    },
    cancel () {
      this.open = false
      this.reset()
    },
    changeStatus (e) {
      const status = e.target.value
      this.form.status = status === '0' ? '1' : '0'
    },
    reset () {
      this.formType = 1
      this.form = {
        id: undefined,
        noticeTitle: undefined,
        noticeTitleEn: undefined,
        noticeType: 1,
        noticeContent: '',
        noticeContentEn: '',
        imgUrl: null,
        status: 1,
        bstatus: 1
      }
    },
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      const noticeId = id
      getNotice(noticeId).then(response => {
        const d = response.data || {}
        const str = d.status
        const merged = { ...this.form, ...d }
        if (merged.noticeTitle == null) merged.noticeTitle = ''
        if (merged.noticeTitleEn == null) merged.noticeTitleEn = ''
        if (merged.noticeContent == null) merged.noticeContent = ''
        if (merged.noticeContentEn == null) merged.noticeContentEn = ''
        if (merged.noticeType != null) {
          merged.noticeType = Number(merged.noticeType)
        }
        this.$set(merged, 'bstatus', str)
        this.form = merged
        this.open = true
        this.$nextTick(() => {
          if (this.$refs.form) {
            this.$refs.form.clearValidate()
          }
        })
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            updateNotice(this.form).then(response => {
              this.$message.success(
                this.$t('views.systemNotice.msg.updateOk'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addNotice(this.form).then(response => {
              this.$message.success(
                this.$t('views.systemNotice.msg.addOk'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    back () {
      const pages = this.$store.pages
      pages.indexOf(this.$route)
      events.$emit('close', pages.indexOf(this.$route))
      this.$router.push('/system/notice')
    },
    onClose () {
      this.open = false
    },
    handleSubmit () {
      this.$refs.baseForm.validate(valid => {
        if (valid) {
          this.open = true
        } else {
          return false
        }
      })
    }
  }
}
</script>
